import UniCore from '../uni-core/js/uni-core.min.js';

// expose UniCore globalement
window.UniCore = UniCore;
export default UniCore;
